<template lang="pug">
a(
  :is="tag",
  :to="routo",
  :href="href",
  :target="target",
  @click="click"
)
  slot {{ text }}
</template>

<script>
export default {
  name: 'ext-link',
  props: {
    text: String,
    to: String | Object,
    callback: Function,
    stopPropagation: {
      type: String | Boolean,
      default: false,
    },
    preventDefault: {
      type: String | Boolean,
      default: false,
    },
    target: String,
    external: Boolean,
  },
  computed: {
    isRouterLink() {
      if (!this.$route) return false;
      if (typeof this.to === 'object') return true;
      return !(
        this.isExternal ||
        this.preventDefault !== false ||
        this.callback
      );
    },
    routo() {
      return this.isRouterLink ? (this.to ? this.to : {}) : false;
    },
    tag() {
      return this.isRouterLink ? 'router-link' : 'a';
    },
    href() {
      if (this.to === undefined) {
        return '#';
      }
      if (this.isRouterLink || this.preventDefault || this.stopPropagation) {
        return this.$router.resolve(this.to).href;
      }
      return this.to;
    },
    isExternal() {
      return this.external
        ? this.external
        : this.target && this.target != '_self';
    },
  },
  methods: {
    click($event) {
      if (this.stopPropagation !== false) {
        $event.stopPropagation();
      }
      if (this.preventDefault !== false) {
        $event.preventDefault();
      }
      if (this.callback) {
        this.callback($event);
        return;
      }
      if (!this.isExternal) {
        this.$emit('click', $event);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// Link.vue?11f3cea0